const HEADER_OFFSET = 54 + 48; // padding plus navbar height

// Smooth-scrolls a section to just under the sticky header.
export const scrollToSection = (id: string) => {
  const element = document.getElementById(id);
  if (!element) return;
  window.scrollTo({
    top: element.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET,
    behavior: "smooth",
  });
};

export const shouldShowRatings = (rating: any) => Boolean(rating >= "4.0"); // P1D-3500

// Desktop rating click: the reviews panel when the property has a review summary (reviews V2),
// otherwise the reviews section.
export const openReviews = (data: any) => {
  if (data?.meta?.review_summary?.summary) {
    window.dispatchEvent(new Event("open-reviews-panel"));
    return;
  }
  scrollToSection("reviews");
};
